











import {Component, Prop, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {monthName} from "@common/dateTimeHelper";

@Component({
    name: "DateView"
})
export default class DateView extends Vue {
    @Prop({required: true}) date: DateTime;

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get day() {
        return this.date.day
    }

    get month() {
        return monthName(this.date.month, this.lang)
    }

    get isToday() {
        return this.date.toISODate() === DateTime.local().toISODate();
    }
}
